// src/state/modules/layout.js
const getInitialLanguage = () => {
    const savedLang = localStorage.getItem('lang')
    if (savedLang) return savedLang

    const browserLang = navigator.language.split('-')[0]
    const supportedLangs = ['en', 'ru', 'ka']
    const initialLang = supportedLangs.includes(browserLang) ? browserLang : 'en'

    localStorage.setItem('lang', initialLang)
    return initialLang
}

const getSavedLayoutSettings = () => {
    const saved = localStorage.getItem('layout')
    try { return saved ? JSON.parse(saved) : {} } catch { return {} }
}

const saveStateToLocalStorage = (state) => {
    const { language, ...layoutSettings } = state
    localStorage.setItem('layout', JSON.stringify(layoutSettings))
    localStorage.setItem('lang', language)
}

export const state = {
    layoutType: 'vertical',
    layoutWidth: 'fluid',
    sidebarSize: 'lg',
    topbar: 'dark',
    mode: 'light',
    position: 'fixed',
    sidebarView: 'default',
    sidebarColor: 'dark',
    sidebarImage: 'none',
    preloader: 'disable',
    visibility: 'show',
    ...getSavedLayoutSettings(),
    language: getInitialLanguage(),
    sheetFirstColWidth: 320,

}

export const mutations = {
    CHANGE_SHEET_FIRST_COL_WIDTH: (s, v) => {
        const n = Number(v)
        s.sheetFirstColWidth = Number.isFinite(n) && n > 0 ? Math.round(n) : 320
        saveStateToLocalStorage(s)
    },
    CHANGE_LAYOUT:        (s, v) => { s.layoutType   = v; saveStateToLocalStorage(s) },
    CHANGE_LAYOUT_WIDTH:  (s, v) => { s.layoutWidth  = v; saveStateToLocalStorage(s) },
    CHANGE_SIDEBAR_TYPE:  (s, v) => { s.sidebarSize  = v; saveStateToLocalStorage(s) },
    CHANGE_TOPBAR:        (s, v) => { s.topbar       = v; saveStateToLocalStorage(s) },
    CHANGE_MODE:          (s, v) => { s.mode         = v; saveStateToLocalStorage(s) },
    CHANGE_POSITION:      (s, v) => { s.position     = v; saveStateToLocalStorage(s) },
    CHANGE_SIDEBAR_VIEW:  (s, v) => { s.sidebarView  = v; saveStateToLocalStorage(s) },
    CHANGE_SIDEBAR_COLOR: (s, v) => { s.sidebarColor = v; saveStateToLocalStorage(s) },
    CHANGE_SIDEBAR_IMAGE: (s, v) => { s.sidebarImage = v; saveStateToLocalStorage(s) },
    CHANGE_PRELOADER:     (s, v) => { s.preloader    = v; saveStateToLocalStorage(s) },
    CHANGE_VISIBILITY:    (s, v) => { s.visibility   = v; saveStateToLocalStorage(s) },
    CHANGE_LANGUAGE:      (s, v) => { s.language     = v; saveStateToLocalStorage(s) },

    RESET_LAYOUT(s) {
        const d = {
            layoutType: 'vertical',
            layoutWidth: 'fluid',
            sidebarSize: 'lg',
            topbar: 'light',
            mode: 'light',
            position: 'fixed',
            sidebarView: 'default',
            sidebarColor: 'dark',
            sidebarImage: 'none',
            preloader: 'disable',
            visibility: 'show',
            sheetFirstColWidth: 320,
        }
        Object.assign(s, d)
        saveStateToLocalStorage(s)
    },
}

export const actions = {
    changeLayoutType:  ({ commit }, { layoutType }) => commit('CHANGE_LAYOUT', layoutType),
    changeLayoutWidth: ({ commit }, { layoutWidth }) => commit('CHANGE_LAYOUT_WIDTH', layoutWidth),
    changeSidebarSize: ({ commit }, { sidebarSize }) => commit('CHANGE_SIDEBAR_TYPE', sidebarSize),
    changeTopbar:      ({ commit }, { topbar }) => commit('CHANGE_TOPBAR', topbar),
    changeMode:        ({ commit }, { mode }) => commit('CHANGE_MODE', mode),
    changePosition:    ({ commit }, { position }) => commit('CHANGE_POSITION', position),
    changeSidebarView: ({ commit }, { sidebarView }) => commit('CHANGE_SIDEBAR_VIEW', sidebarView),
    changeSidebarColor:({ commit }, { sidebarColor }) => commit('CHANGE_SIDEBAR_COLOR', sidebarColor),
    changeSidebarImage:({ commit }, { sidebarImage }) => commit('CHANGE_SIDEBAR_IMAGE', sidebarImage),
    changePreloader:   ({ commit }, { preloader }) => commit('CHANGE_PRELOADER', preloader),
    changeVisibility:  ({ commit }, { visibility }) => commit('CHANGE_VISIBILITY', visibility),
    changeLanguage:    ({ commit }, { language }) => commit('CHANGE_LANGUAGE', language),
    resetLayout:       ({ commit }) => commit('RESET_LAYOUT'),
    changeSheetFirstColWidth: ({ commit }, { sheetFirstColWidth }) =>
        commit('CHANGE_SHEET_FIRST_COL_WIDTH', sheetFirstColWidth),
}
